export default "__VITE_ASSET__70bc1f1e__"